module.exports = __webpack_public_path__ + "img/ring_0_0_1_1@3x.bb523b0a.png";